import React from "react";
import { useQuery } from "@/hooks/useQuery";
import { formResponsesPathEntry, useYDoc, viewsPathEntry } from "@/hooks/useY";
import useExtensions from "@/hooks/view/useExtensions";
import { FormResponse, FormView } from "@/types/form";
import { Paper } from "@mui/material";
import { RichTextReadOnly } from "mui-tiptap";

const ViewFormPage = () => {
  const { formResponseId, viewId } = useQuery();
  const [views] = useYDoc<FormView[]>([viewsPathEntry], []);
  const [formResponses] = useYDoc<FormResponse | undefined>(
    [formResponsesPathEntry, { type: "array", value: formResponseId }],
    undefined
  );

  const view = views.find((view) => view.id === viewId)!;

  const extensions = useExtensions({
    formDefinition: formResponses!.formDefinition,
    responses: formResponses!.responses,
  });

  return (
    <Paper
      elevation={0}
      sx={{ minHeight: "100%", padding: "1.5em", position: "relative" }}
    >
      <RichTextReadOnly content={view.content} extensions={extensions} />
    </Paper>
  );
};

export default ViewFormPage;
